var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertbell14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 16.3333C7.91665 16.3333 8.66665 15.5833 8.66665 14.6667H5.33331C5.33331 15.5833 6.08331 16.3333 6.99998 16.3333ZM12 11.3333V7.16667C12 4.60834 10.6416 2.46667 8.24998 1.9V1.33334C8.24998 0.641669 7.69165 0.0833359 6.99998 0.0833359C6.30831 0.0833359 5.74998 0.641669 5.74998 1.33334V1.9C3.36665 2.46667 1.99998 4.6 1.99998 7.16667V11.3333L0.333313 13V13.8333H13.6666V13L12 11.3333ZM10.3333 12.1667H3.66665V7.16667C3.66665 5.1 4.92498 3.41667 6.99998 3.41667C9.07498 3.41667 10.3333 5.1 10.3333 7.16667V12.1667Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertbell14);
export default __webpack_public_path__ + "97131/static/media/alertbell14.00ac3dd32f1e7217191fe1132048e82a.svg";
export { ForwardRef as ReactComponent };